module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAAMNJREFUOE+t1KENAjEUxvH/5xAILIKEPRAsgDiBYAQkAyBAMAADMAJBEARTIAkOyQgIkpKXcElz1+Pueq1tvt9rXvsqEi2FHOdcH5gAD0nPJrVKkHOuB9yBMfAGMknXOiwEzYCzF/wAC0nHf1gIyoBTIWTYUtKhCmsK5fmVpH0IawuZsZG0LWIxkBlrSTsfi4WsZyNJrxyLhSw/TAGV+hRzoiTN7nz9UQ8y2YgMgJs3tHNJl9ZDa4HfDzDt9I3UVa7a/wL8k1cTfRNi9wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zone/img11.png
// module id = yBKG
// module chunks = 1